import { Item, Skeleton, Tooltip, lucideIcons } from '@round/creatorbase-ui';
import { Currency } from '@round/api';
import { asMoneyWithoutZeros } from 'helpers';
import cn from 'classnames';

import styles from './PostCostFeesBreakdown.module.css';

const { Info } = lucideIcons;

type Props = {
    campaignCurrency: Currency | undefined;
    totalCost: number | null | undefined;
    isTotalLoading: boolean;
    hasAmountError?: boolean;
};

const PostCostFeesBreakdown = ({ campaignCurrency, totalCost, isTotalLoading, hasAmountError }: Props) => {
    return (
        <Item variant="outline" size="sm" className={cn(styles.totalItem, { [styles.totalItemError]: hasAmountError })}>
            <Item.Content>
                <Item.Title className={styles.totalTitle}>
                    <span>Total Cost</span>
                    <Tooltip>
                        <Tooltip.Trigger>
                            <Info className={styles.infoIcon} />
                        </Tooltip.Trigger>
                        <Tooltip.Content>Includes estimated fees</Tooltip.Content>
                    </Tooltip>
                </Item.Title>
            </Item.Content>

            <Item.Actions className={styles.amount}>
                {isTotalLoading ? (
                    <Skeleton className={styles.skeleton} />
                ) : (
                    <>
                        <span className={cn({ [styles.amountError]: hasAmountError })}>
                            {asMoneyWithoutZeros(totalCost, campaignCurrency)}
                        </span>
                        {campaignCurrency?.name ? (
                            <span className={cn(styles.currencyName, { [styles.amountError]: hasAmountError })}>
                                {campaignCurrency.name}
                            </span>
                        ) : null}
                    </>
                )}
            </Item.Actions>
        </Item>
    );
};

export default PostCostFeesBreakdown;
